/**
 * @desc 发起会员个人认证
 */
import {
  AuditPersonEntity,
  AuditPersonForm
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateAuditPersonParameter = AuditPersonForm

const method = 'POST'
const url = '/auth/audit/person'

export const createAuditPersonApi = (
  data?: CreateAuditPersonParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditPersonEntity>({
    method,
    url,
    data,
    ...config
  })
}

createAuditPersonApi.method = method
createAuditPersonApi.url = url
